module.exports = "/images/vendor/dhtmlx-scheduler/codebase/imgs/collapse_expand_icon.gif?e30c26066e89dc3db72d452cfe19d86b";